let metadata = null;
const setMetadata = (newMetadata) => {
  metadata = newMetadata;
};
const getMetadata = () => {
  if (!metadata) {
    throw new Error("Cannot get metadata before initializing");
  }
  return metadata;
};
export {
  getMetadata,
  setMetadata
};
//# sourceMappingURL=metadata.js.map